__turbopack_context__.v({
  "accordion-reference": "WxWvfa_accordion-reference",
  "ant-collapse-content": "WxWvfa_ant-collapse-content",
  "ant-collapse-content-box": "WxWvfa_ant-collapse-content-box",
  "ant-collapse-header": "WxWvfa_ant-collapse-header",
  "ant-collapse-item": "WxWvfa_ant-collapse-item",
  "ant-image": "WxWvfa_ant-image",
  "article-contents": "WxWvfa_article-contents",
  "article-image": "WxWvfa_article-image",
  "bannerImage": "WxWvfa_bannerImage",
  "bannerWrapper": "WxWvfa_bannerWrapper",
  "category": "WxWvfa_category",
  "category-mobile": "WxWvfa_category-mobile",
  "col-btn-share": "WxWvfa_col-btn-share",
  "copy-btn": "WxWvfa_copy-btn",
  "divider": "WxWvfa_divider",
  "faq-answer": "WxWvfa_faq-answer",
  "faq-collapse": "WxWvfa_faq-collapse",
  "faq-panel": "WxWvfa_faq-panel",
  "faq-question": "WxWvfa_faq-question",
  "faq-question-active": "WxWvfa_faq-question-active",
  "faq-title": "WxWvfa_faq-title",
  "faq-wrapper": "WxWvfa_faq-wrapper",
  "img-wrapp-share": "WxWvfa_img-wrapp-share",
  "list": "WxWvfa_list",
  "list-category": "WxWvfa_list-category",
  "list-desc": "WxWvfa_list-desc",
  "list-divider": "WxWvfa_list-divider",
  "list-img": "WxWvfa_list-img",
  "list-reviewer": "WxWvfa_list-reviewer",
  "list-title": "WxWvfa_list-title",
  "page-break-section": "WxWvfa_page-break-section",
  "related": "WxWvfa_related",
  "row-detail-share": "WxWvfa_row-detail-share",
  "share-btn": "WxWvfa_share-btn",
  "sosmed": "WxWvfa_sosmed",
  "title": "WxWvfa_title",
  "wrap-article-detail": "WxWvfa_wrap-article-detail",
});
